import styled from 'styled-components';

// CONSTANTS
import { WHITE, BLACK } from '@/constants/colors';

const ServiceCardStyled = styled.div`
  position: relative;

  padding: 32px 16px;

  height: 190px;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;

  border-radius: 12px;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    z-index: -1;

    background: ${({ $backgroundImage }) =>
      $backgroundImage ? `url('${$backgroundImage}')` : BLACK};
    background-repeat: no-repeat;
    background-size: cover;
  }

  .service-card {
    &__img-wrapper {
      height: 98px;
      width: 160px;

      padding: 10px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;

      border-radius: 16px;
      background-color: ${WHITE};

      img {
        width: 100%;
        height: auto;
      }
    }

    &__title {
      color: ${WHITE};
      margin-top: 8px;
    }
  }
`;

export default ServiceCardStyled;
